import React, { useState } from "react";
import moment from "moment";
import * as notify from "../../../shared/notify";

import Modal from "../../modal";

import { DatePicker } from "../../form-inputs/inputs/date";
import { WithLabel } from "../../form-inputs/components/with-label";

const DateWithLabel = WithLabel(DatePicker);

const buildButtonLabel = (showFilterDates, setLabel) => {
    let dateString = "";

    if (showFilterDates.filterFromDate) dateString += `${moment(showFilterDates.filterFromDate).format("MM/DD")}`;
    else dateString += "All ";

    if (showFilterDates.filterToDate) dateString += ` - ${moment(showFilterDates.filterToDate).format("MM/DD")}`;
    else dateString += " - All";

    if (!showFilterDates.filterFromDate && !showFilterDates.filterToDate) dateString = "Filter Dates";

    setLabel && setLabel(dateString);

    return dateString;
};

export const DueDateFilterButton = (props) => {
    const [showModal, setShowModal] = useState(false);

    // Load up a copy of the filter prop into local state, when available
    const [showFilterDates, setFilterDates] = useState(props.filterProp ? { ...props.filterProp.value } : {});

    // This will allow us to set default state without having to submit first
    const [showBtnLabel, setBtnLabel] = useState(buildButtonLabel(showFilterDates));

    const closeModal = () => {
        setShowModal(false);
    };

    const filterDateModalShow = (e) => {
        e.preventDefault();
        e.stopPropagation();

        setShowModal(true);
    };

    const handleDateFilterSubmission = (e) => {
        e.preventDefault();

        if (
            showFilterDates.filterToDate &&
            showFilterDates.filterFromDate &&
            !moment(showFilterDates.filterToDate).isSameOrAfter(showFilterDates.filterFromDate)
        ) {
            notify.warning('Date range will contain no results. "From" date should be before "To" date.');
        }

        props.onChangeProp(showFilterDates);
        buildButtonLabel(showFilterDates, setBtnLabel);

        setShowModal(false);
    };

    const handleDateChange = (name, value) => {
        setFilterDates({
            ...showFilterDates,
            [name]: value,
        });
    };

    return (
        <>
            <Modal
                show={showModal}
                onClose={closeModal}
            >
                <h3>Filter by date</h3>

                <DateWithLabel
                    name="filterFromDate"
                    label="From"
                    emitAsString
                    updateOnChange={handleDateChange}
                    value={showFilterDates.filterFromDate || ""}
                    enableIcon
                    isClearable
                    minDate={props.minDate}
                />
                <DateWithLabel
                    name="filterToDate"
                    label="To"
                    emitAsString
                    updateOnChange={handleDateChange}
                    value={showFilterDates.filterToDate || ""}
                    enableIcon
                    isClearable
                    minDate={props.minDate}
                />

                <button
                    type="submit"
                    className="button -primary -small"
                    onClick={handleDateFilterSubmission}
                >
                    Apply Filter
                </button>
            </Modal>
            <button onClick={filterDateModalShow}>{showBtnLabel}</button>
        </>
    );
};
